// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { BookitupNotification } from '../../../../Types/LogT';

const ExternalEmailConnected: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { value } = notification;

  return (
    <Text>
      Deine E-Mails werden nun mit{' '}
      <Text
        span
        weight="bolder"
        sx={(theme) => ({ color: theme.colorScheme === 'dark' ? theme.colors.blue[1] : theme.colors.blue[4] })}
      >
        {value}
      </Text>{' '}
      versendet.
    </Text>
  );
};

export default ExternalEmailConnected;
